// extracted by mini-css-extract-plugin
export default {"skeletonVideo":"VideoSkeleton-module__skeletonVideo_gUUd1"};